
const ColumnCustomizer = ({ 
  allColumns, 
  visibleColumns, 
  setVisibleColumns, 
  onClose ,
  storageKey 
}) => {

  const toggleColumn = (key) => {
    if (visibleColumns.includes(key)) {
      // Don't allow hiding fixed columns
      if (allColumns.find(c => c.key === key && c.fixed)) return;
      
      setVisibleColumns(prev => prev.filter(k => k !== key));
    } else {
      setVisibleColumns(prev => [...prev, key]);
    }
  };

  const saveAndClose = () => {
  localStorage.setItem(storageKey, JSON.stringify(visibleColumns));
  onClose();
};

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-[380px] p-4">
        <h3 className="text-lg font-semibold mb-2">Customize Columns</h3>
        
        <div className="space-y-3 max-h-[400px] overflow-y-auto pr-2">
          {allColumns.map((column) => {
            const isVisible = visibleColumns.includes(column.key);
            const isDisabled = column.fixed;

            return (
              <label 
                key={column.key}
                className={`flex items-center gap-3 pb-2 rounded hover:bg-gray-50 cursor-pointer ${isDisabled ? 'opacity-60' : ''}`}
              >
                <input
                  type="checkbox"
                  checked={isVisible}
                  disabled={isDisabled}
                  onChange={() => toggleColumn(column.key)}
                  className="w-4 h-4 green-bg-H "
                />
                <span className="body-N">{column.label}</span>
                {isDisabled && <span className="text-xs text-gray-400 ml-auto">(Fixed)</span>}
              </label>
            );
          })}
        </div>

        <div className="flex gap-3 mt-3">
          <button
            onClick={onClose}
            className="flex-1 py-3 border border-gray-300 rounded-lg body-S"
          >
            Cancel
          </button>
          <button
            onClick={saveAndClose}
            className="flex-1 py-3 green-bg-H text-white rounded-lg body-S "
          >
            Apply Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default ColumnCustomizer;